export default "__VITE_ASSET__Cz5ia_sD__"